import { FocusTrap } from '../modules/focusTrap';

export class MenuPanel {
    constructor() {
        this.overlay = document.getElementById('menu-overlay');
        this.panel = document.getElementById('menu-panel');
        this.isPanelOpen = false;

        // a11y: 初期状態は非表示なので inert でキーボード/支援技術から隔離
        this.overlay.setAttribute('inert', '');
        this.panel.setAttribute('inert', '');

        // イベント設定
        this.overlay.addEventListener('click', () => this.close());
        this.panel.querySelector('.menu-panel__close')?.addEventListener('click', () => this.close());
        this.panel.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.close();
        });

        this.focusTrap = new FocusTrap(this.panel);
    }
    open() {
        if (this.isPanelOpen)
            return;
        this.isPanelOpen = true;
        this.overlay.setAttribute('aria-hidden', 'false');
        this.overlay.removeAttribute('inert');
        this.overlay.classList.add('menu-overlay--visible');
        this.panel.setAttribute('aria-hidden', 'false');
        this.panel.removeAttribute('inert');
        this.panel.classList.add('menu-panel--open');
        this.focusTrap.activate();
        document.dispatchEvent(new CustomEvent('menupanel:open'));
    }
    close() {
        if (!this.isPanelOpen)
            return;
        this.isPanelOpen = false;
        this.focusTrap.deactivate();
        this.overlay.setAttribute('aria-hidden', 'true');
        this.overlay.setAttribute('inert', '');
        this.overlay.classList.remove('menu-overlay--visible');
        this.panel.setAttribute('aria-hidden', 'true');
        this.panel.setAttribute('inert', '');
        this.panel.classList.remove('menu-panel--open');
        document.dispatchEvent(new CustomEvent('menupanel:close'));
    }
    toggle() {
        if (this.isPanelOpen) {
            this.close();
        }
        else {
            this.open();
        }
    }
}
